// FICHIER : frontend/src/pages/Contact.jsx
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BRAND } from '../constants/brand';
import Logo from '../components/Logo';
import NavLogo from '../components/NavLogo';
import axios from 'axios';

const API = 'https://ark-recruitment-backend.onrender.com/api';

const IconArrow = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>);
const IconMail = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>);
const IconPhone = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>);
const IconMap = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>);
const IconClock = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>);

const INFOS = [
  { icon: <IconMail/>,  label: 'Email',     value: 'contact@tos-rh.com',          sub: 'Reponse sous 24h' },
  { icon: <IconPhone/>, label: 'Telephone',  value: '+242 06 500 00 00',           sub: 'Lun – Ven, 8h – 18h' },
  { icon: <IconMap/>,   label: 'Adresse',    value: 'Brazzaville, Congo',          sub: 'Centre-ville, Tour Nabemba' },
  { icon: <IconClock/>, label: 'Horaires',   value: 'Lundi – Vendredi',            sub: '08h00 – 18h00 (UTC+1)' },
];

export default function Contact() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);

  const [form, setForm] = useState({ nom: '', email: '', sujet: '', message: '' });
  const [envoye, setEnvoye] = useState(false);
  const [sending, setSending] = useState(false);
  const [erreur, setErreur] = useState('');
  const set = (key) => (e) => setForm(f => ({ ...f, [key]: e.target.value }));

  const handleSubmit = async () => {
    if (!form.nom.trim() || !form.email.trim() || !form.message.trim()) return;
    setSending(true);
    setErreur('');
    try {
      await axios.post(`${API}/contact`, form);
      setEnvoye(true);
    } catch (e) {
      setErreur("Erreur lors de l'envoi. Réessayez.");
    } finally {
      setSending(false);
    }
  };

  const inputStyle = { width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 10, padding: '12px 16px', fontSize: 14, color: 'var(--text)', outline: 'none', fontFamily: 'DM Sans,sans-serif' };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', color: 'var(--text)', fontFamily: 'DM Sans,sans-serif' }}>

      {/* NAV */}
      <nav style={{ position: 'sticky', top: 0, zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: isMobile ? '0 20px' : '0 64px', height: 68, background: 'var(--nav-bg)', borderBottom: '1px solid var(--border)' }}>
        <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}><NavLogo/></button>
        {!isMobile && (
          <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: 32 }}>
            <span onClick={() => navigate('/fonctionnalites')} style={{ color: 'var(--muted)', fontSize: 14, fontWeight: 500, cursor: 'pointer' }}>Fonctionnalites</span>
            <span onClick={() => navigate('/comment-ca-marche')} style={{ color: 'var(--muted)', fontSize: 14, fontWeight: 500, cursor: 'pointer' }}>Comment ca marche</span>
            <span style={{ color: 'var(--text)', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>Contact</span>
          </div>
        )}
        <span onClick={() => navigate('/entreprise')} style={{ background: 'var(--accent)', color: '#fff', padding: isMobile ? '8px 16px' : '9px 22px', borderRadius: 8, fontSize: isMobile ? 12 : 13, fontWeight: 500, display: 'inline-flex', alignItems: 'center', gap: 6, cursor: 'pointer', whiteSpace: 'nowrap' }}>
          {isMobile ? 'Espace entreprise' : 'Creer ma marque employeur'} <IconArrow/>
        </span>
      </nav>

      {/* HERO */}
      <section style={{ padding: isMobile ? '48px 20px 32px' : '72px 64px 48px', maxWidth: 1240, margin: '0 auto', textAlign: 'center' }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, color: 'var(--accent2)', fontSize: 11, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>
          <span style={{ width: 24, height: 1, background: 'var(--accent2)', display: 'inline-block' }}/> Contact
        </div>
        <h1 style={{ fontFamily: 'Syne,sans-serif', fontSize: isMobile ? 'clamp(26px,7vw,36px)' : 'clamp(28px,3vw,42px)', fontWeight: 800, lineHeight: 1.1, letterSpacing: '-1.5px', maxWidth: 600, margin: '0 auto 16px' }}>
          Parlons de votre recrutement
        </h1>
        <p style={{ color: 'var(--muted)', fontSize: isMobile ? 15 : 17, maxWidth: 500, margin: '0 auto', lineHeight: 1.7 }}>
          Une question, un besoin specifique, un partenariat ? Notre equipe vous repond sous 24 heures.
        </p>
      </section>

      {/* CONTENU */}
      <section style={{ padding: isMobile ? '0 20px 48px' : '0 64px 80px', maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? 32 : 48 }}>

          {/* FORMULAIRE */}
          <div>
            {envoye ? (
              <div style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '48px 32px', textAlign: 'center' }}>
                <div style={{ width: 64, height: 64, margin: '0 auto 20px', borderRadius: '50%', background: 'rgba(22,163,74,0.08)', border: '1px solid rgba(22,163,74,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#16A34A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
                <h3 style={{ fontFamily: 'Syne,sans-serif', fontSize: 20, fontWeight: 800, marginBottom: 8 }}>Message envoye !</h3>
                <p style={{ color: 'var(--muted)', fontSize: 14, lineHeight: 1.7 }}>Merci pour votre message. Notre equipe vous repondra sous 24 heures.</p>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div style={{ fontFamily: 'DM Mono,monospace', fontSize: 11, color: 'var(--muted)', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 4 }}>
                  Envoyez-nous un message
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 16 }}>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--muted)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.3 }}>Nom complet *</label>
                    <input type="text" value={form.nom} onChange={set('nom')} placeholder="Jean Dupont" style={inputStyle}/>
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--muted)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.3 }}>Email *</label>
                    <input type="email" value={form.email} onChange={set('email')} placeholder="jean@entreprise.com" style={inputStyle}/>
                  </div>
                </div>

                <div>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--muted)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.3 }}>Sujet</label>
                  <input type="text" value={form.sujet} onChange={set('sujet')} placeholder="Ex : Demande de demo, Partenariat..." style={inputStyle}/>
                </div>

                <div>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--muted)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.3 }}>Message *</label>
                  <textarea value={form.message} onChange={set('message')} placeholder="Decrivez votre besoin ou posez votre question..." rows={6} style={{ ...inputStyle, resize: 'vertical', lineHeight: 1.6 }}/>
                </div>

                {erreur && (<div style={{ background: 'rgba(220,38,38,0.04)', border: '1px solid rgba(220,38,38,0.12)', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: 'var(--error)', marginBottom: 12 }}>{erreur}</div>)}

                <button onClick={handleSubmit} disabled={sending} style={{ width: '100%', background: sending ? 'var(--border)' : 'var(--accent)', color: '#fff', border: 'none', borderRadius: 10, padding: '13px 20px', fontSize: 15, fontWeight: 600, fontFamily: 'DM Sans,sans-serif', cursor: sending ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 4 }}>
                  {sending ? 'Envoi en cours...' : (<>Envoyer le message <IconArrow/></>)}
                </button>
              </div>
            )}
          </div>

          {/* INFOS CONTACT */}
          <div>
            <div style={{ fontFamily: 'DM Mono,monospace', fontSize: 11, color: 'var(--muted)', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 20 }}>
              Informations de contact
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 32 }}>
              {INFOS.map(info => (
                <div key={info.label} style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '20px', display: 'flex', alignItems: 'flex-start', gap: 16 }}>
                  <div style={{ width: 44, height: 44, background: 'var(--accent-08)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent)', flexShrink: 0 }}>
                    {info.icon}
                  </div>
                  <div>
                    <div style={{ fontFamily: 'DM Mono,monospace', fontSize: 10, color: 'var(--muted)', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 4 }}>{info.label}</div>
                    <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--text)', marginBottom: 2 }}>{info.value}</div>
                    <div style={{ fontSize: 12, color: 'var(--muted)' }}>{info.sub}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* FAQ rapide */}
            <div style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '24px' }}>
              <div style={{ fontFamily: 'Syne,sans-serif', fontSize: 15, fontWeight: 700, marginBottom: 16 }}>Questions frequentes</div>
              {[
                { q: 'Est-ce gratuit ?', a: "L'inscription et la construction de votre marque employeur sont gratuites. Les fonctionnalites avancees seront disponibles en version premium." },
                { q: 'Combien de temps pour demarrer ?', a: "Moins de 10 minutes. Creez votre compte, repondez aux questions, et votre ADN employeur est genere automatiquement." },
                { q: 'Mes donnees sont-elles securisees ?', a: "Oui. Hebergement securise, aucun partage avec des tiers, acces restreint a votre compte." },
              ].map((faq, i) => (
                <div key={i} style={{ paddingBottom: i < 2 ? 14 : 0, marginBottom: i < 2 ? 14 : 0, borderBottom: i < 2 ? '1px solid var(--border)' : 'none' }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)', marginBottom: 4 }}>{faq.q}</div>
                  <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.6 }}>{faq.a}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ borderTop: '1px solid var(--border)', padding: isMobile ? '28px 20px' : '36px 64px', display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'center', alignItems: 'center', gap: 40, color: 'var(--muted)', fontSize: 13, textAlign: isMobile ? 'center' : 'left' }}>
        <Logo height={28}/>
        <div>&copy; {BRAND.year} {BRAND.name}</div>
      </footer>
    </div>
  );
}
